import React, { useEffect, useMemo, useRef, useState } from "react";
import InputBox from "../InputBox/InputBox";
import { ArrowIcon } from "../../Assets/assets";
import Button from "../Button/Button";
import "./Filters.css";

export default function DateInput(props) {
  const dropdownRef = useRef(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscKey);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscKey);
    };
    // eslint-disable-next-line
  }, []);

  const isFilterApplied = useMemo(() => {
    if (typeof props.isFilterApplied === "boolean") {
      return props.isFilterApplied;
    } else {
      const applied = props.appliedFilters?.[props.data.key];
      if (applied?.type && applied?.type !== "Lifetime") {
        return true;
      } else {
        return false;
      }
    }
    // eslint-disable-next-line
  }, [props.appliedFilters, props.isFilterApplied]);

  const isSelectedNotApplied = useMemo(() => {
    const selected = props.selectedFilters?.[props.data.key];
    const applied = props.appliedFilters?.[props.data.key];
    return !(selected === applied);
  }, [props.selectedFilters, props.appliedFilters, props.data.key]);

  return (
    <div
      data-cy={`${props?.["data-cy"]}-SELECT-FILTER`}
      style={{
        width: "fit-content"
      }}
      ref={dropdownRef}
      className={`${props.disabled ? "cursor-no-drop" : "cursor-pointer"}`}
    >
      <div
        onClick={() => {
          if (!props.disabled) {
            setShow(!show);
          }
        }}
        style={{
          ...(show || isFilterApplied
            ? {
                backgroundColor: "var(--tertiaryColor4)",
                border: "solid 1px var(--tertiaryColor5)"
              }
            : { border: "solid 1px transparent" }),
          ...(!show && isSelectedNotApplied
            ? { border: "solid 1px var(--tertiaryColor5)" }
            : {})
        }}
        className={`display-flex flex-align-items-center padding-default`}
      >
        {!show && isSelectedNotApplied && (
          <div
            style={{
              top: "-2px",
              right: "-2px",
              borderRadius: "50%",
              width: "7px",
              height: "7px",
              backgroundColor: "#1c1c1c",
              zIndex: 200
            }}
            className="position-absolute flex-justify-content-center flex-align-items-center"
          >
            <div
              style={{
                backgroundColor: "var(--secondaryColor)",
                width: "6px",
                height: "6px",
                borderRadius: "50%"
              }}
            />
          </div>
        )}
        <div className="font-color-tertiaryColor6 font-size-small white-space-nowrap">
          {props.data.title}
        </div>
        <div className="font-size-medium font-color-tertiaryColor padding-left-small white-space-nowrap padding-right-small">
          {props.selectedFilters?.[props.data.key]}
        </div>
        <div
          style={{
            height: "16px",
            width: "16px"
          }}
        >
          <ArrowIcon color="var(--tertiaryColor6)" />
        </div>
      </div>

      {show && (
        <div
          style={{
            height: "220px",
            width: "250px",
            top: "42px",
            zIndex: 200
          }}
          className="position-absolute padding-large box-shadow-default background-color-tertiaryColor2 font-color-tertiaryColor display-flex flex-direction-column flex-justify-content-space-between"
        >
          <CustomDate
            data={props.data}
            setSelectedFilters={props.setSelectedFilters}
            selectedFilters={props.selectedFilters}
            multiple={props.multiple}
          />

          <div
            className={`display-flex margin-top-large ${
              props.data.options.length < 6 ? "" : "margin-bottom-large"
            } flex-justify-content-space-between`}
          >
            <div className="inherit-parent-width">
              <Button
                data-cy={`${props?.["data-cy"]}-CUSTOM-SELECT-RESET-BUTTON`}
                variant="danger"
                text="Reset"
                boxShadow={false}
                className="inherit-parent-width padding-left-large padding-right-large"
                onClick={() => {
                  props.onResetClick(props.data.key);
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const CustomDate = (props) => {
  return (
    <div>
      <div className="display-flex">
        <div className=" font-size-medium font-color-tertiaryColor">
          SELECT DATE
        </div>
      </div>
      <InputBox
        className="inherit-parent-width padding-top-large"
        name="date"
        label="Date"
        type="date"
        size="small"
        value={props.selectedFilters?.[props.data.key] || ""}
        removeResponsive={true}
        fontColor="font-color-tertiaryColor"
        labelFontColor="font-color-tertiaryColor"
        data-cy="FILTER-DATE-FIELD"
        required
        onChange={(e) => {
          props.setSelectedFilters({
            ...props.selectedFilters,
            date: e.target.value
          });
        }}
      />
    </div>
  );
};
